// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

// Polyfills
import 'mdn-polyfills/Element.prototype.closest';

// Vendor
import 'sticky-kit/dist/sticky-kit';
import 'truncate.js';
import template from 'lodash/template';
import LazyLoad from "vanilla-lazyload";
import Choices from 'choices.js';
import StarRating from './star-rating.js';

// Modules
import Bonuses from '../_modules/bonuses/bonuses';
import ProductItemSlider from '../_modules/product-item-slider/product-item-slider';
import ProductDetailCalc from '../_modules/product-detail-calc/product-detail-calc';
import ProductDetailFeedback from '../_modules/product-detail-feedback/product-detail-feedback';
import CompareProducts from '../_modules/compare-products/compare-products';
import { ActionCounters } from '../_modules/action-counter/action-counter';
import Tabodion from '../_modules/tabodion/tabodion';
import { MoreTexts } from '../_modules/moreText/moreText';
import Accordion from '../_modules/accordion/accordion';
import Switcher from '../_modules/switcher/switcher';
import FormsHandler from '../_modules/forms-handler/forms-handler';
import RentOfferCalc from '../_modules/rent-offer-calc/rent-offer-calc';
import Services from '../_modules/services/services';
import Rating from '../_modules/rating/rating';
import ModalGallery from '../_modules/modal-gallery/modal-gallery';
import TerminalId from '../_modules/terminal-id/terminal-id';
import OrdersControls from '../_modules/orders-controls/orders-controls';
import ProductItemsSearch from '../_modules/product-items-search/product-items-search';
import CategoryFilter from '../_modules/category-filter/category-filter';
import CalculatorModal from '../_modules/calculator-modal/calculator-modal';
import initBasketButtonsHandler from '../_modules/basket-buttons-handler/basket-buttons-handlers';
import ProductAvailability from '../_modules/product-availability/product-availability';
import QuantityControl from '../_modules/quantity-control/quantity-control';
import DiscountRequestModal from '../_modules/discount-request-modal/discount-request-modal';
import RenderedMenu from '../_modules/rendered-menu/rendered-menu';
import BigSlider from '../_modules/big-slider/big-slider';
import ContactsMap from '../_modules/contacts-map/contacts-map';
import ShowMoreBlock from '../_modules/show-more-block/show-more-block';
import ProductCard from '../_modules/product-card/product-card';
import ModalFastViewSlider from '../_modules/modal-fast-view-slider/modal-fast-view-slider';
import SortBlock from '../_modules/sort-block/sort-block';
import FixedContent from '../_modules/fixed-content/fixed-content';
import { InputModernFactory } from '../_modules/input-modern/input-modern';
import AuthModal from '../_modules/auth-modal/auth-modal';
import Checkout from '../_modules/checkout/app';
import BonusB2bModal from '../_modules/bonus-b2b-modal/bonus-b2b-modal';
import UserConsent from '../_modules/user-consent/user-consent';
import Compare from '../_modules/compare/app';

import "../_scripts/inrt";
import CityDropdown from "../_modules/city-dropdown/city-dropdown";
import ContentFilter from "../_modules/content-filter/content-filter";
initCustom();

function initCustom() {
	window.template = template;
	window.initSelects = initSelects;
	window.initUserConsent = initUserConsent;
	$(function() {
		initLazyLoad();
		initCityDropdown();
		checkBX();
		initBackBtn();
		initCheckUserCity();
		initSelects();
		initFormsValidate();
		initProductDetailCalc();
		initQuantityCounter();
		initProductSlider();
		initToCart(false, true);
		initProductFeedback();
		initActionCounter();
		initTabodion();
		initMoreTexts();
		scrollToElement();
		clickToElement();
		initAccordions();
		modalReInit();
		initForms();
		initCardNumValidation();
		closeAllModalsHandler();
		initTextTruncate();
		initBonuses();
		initRating();
		initModalGallery();
		triggerAuthModal();
		fixCheckoutEmailField();
		loadModalByClick();
		initTerminalId();
		dateRange();
		ordersControls();
		orderedItemsSearch();
		//initCategoryFilter();
		fastViewModalInit();
		initInfoModal();
		initNeedPayModal();
		initInfoPopup();
		initHeaderLoginMessage();
		initProductAvailability();
		bindCardInCart();
		initQuantityControls();
		initCalculator();
		initBasketButtonsHandler();
		initGiftBonusesModal();
		initAppInstallModal();
		initPhoneAuthSuccessModal();
		initEventOrderBtn();
		//initCatalogFilters();
		new RenderedMenu();
		initBigSlider();
		new ContactsMap();
		initShowMoreCatalog();
		initProductCard();
		initSortBlock();
		initFixedContent();
		initInputModern();
		initCheckout();
		initBXPageObject();
		initVideoConsultationButtons();
		initEcommClick();
		initUserConsent();
		initAnalytics();
		initComparePage();
		let reviews = document.querySelector("#reviews");
		if (reviews) {
			let reviewsClass = new ContentFilter({root: reviews});
			reviewsClass.init();
		}
		window.loadModalByUrl = loadModalByUrl;
		window.loadStaticModal = loadStaticModal;
		window.initRating = initRating;
		window.initCartButtons = initCartButtons;
		window.initQuantityControls = initQuantityControls;
		window.initInputModern = initInputModern;
		window.initFullProductCard = initFullProductCard;

		if (typeof window.popupUrl != "undefined") {
			loadModalByUrl(window.popupUrl);
		}

		if (window.showBonusB2bModal === true) {
			loadModalByUrl("/include/modals/bonusProgramB2b.php", {
				modalParams: {
					escapeClose: false,
					clickClose: false
				}
			});
		}
	})

	if (window.BX) {
		BX.addCustomEvent('onSlideInit', function() {
			initProductCard();
			loadModalByClick();
		});
	}

	function initLazyLoad() {
		new LazyLoad({
			elements_selector: ".lazy",
			unobserve_entered: true
		});
	}

	function initCartButtons() {
		initQuantityCounter();
		initToCart(true);
	}

	function initBackBtn() {
		let btn = document.querySelector('[data-back-btn]');
		if (btn) {
			btn.addEventListener("click", (e) => {
				window.history.back();
			})
		}
	}

	function initCheckUserCity() {
		if (!BX.browser) return false;
		if (BX.browser.IsMobile() && window.isFirstVisit) {
			if (window.ymapsReady) {
				ymaps.ready(init);
			} else {
				document.addEventListener('ymaps-ready', e => { ymaps.ready(init); });
			}
            function init() {
                 ymaps.geolocation.get({
                     //provider: 'yandex',
                     provider: 'browser',
                     autoReverseGeocode: true
                 }).then(function (result) {
					 var arrCity = new Map([
						 ['Астрахань', 77385],
						 ['Волжский', 154188],
						 ['Липецк', 77386],
						 ['Магнитогорск', 210963],
						 ['Орел', 178740],
						 ['Орёл', 178740],
					 ]);
					 const localityName = result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName');
					 if(typeof localityName != "undefined" && localityName !== ''){
						 var mobile_city_id = arrCity.get(localityName);
					 }else{
						 const arLocalities = result.geoObjects.get(0).getLocalities();
						 if (Array.isArray(arLocalities)){
							 arLocalities.forEach(function(item, i, arLocalities) {
								 var find_city = arrCity.get(item);
								 if(typeof find_city != "undefined"){
									 var mobile_city_id = find_city;
								 }
							 });
						 }
					 }
					 if(typeof mobile_city_id != "undefined"){
						 if ($.cookie("CURRENT_CITY_ID") != mobile_city_id){
							 const data = {
								 city: mobile_city_id
							 }
							 $.ajax({
								 url: window.location.href,
								 data,
								 success: function(res) {
									 const CITY_SELECTED_COOKIE         = "city_selected_v1";
									 const CITY_SELECTED_COOKIE_EXPIRES = 10000;
									 $.cookie(CITY_SELECTED_COOKIE, "selected", { expires : CITY_SELECTED_COOKIE_EXPIRES, path: "/"});
									 window.location.reload();
								 }
							 });
						 }
					 }else{
						 const data = {
							 city: 77385
						 }
						 $.ajax({
							 url: window.location.href,
							 data,
							 success: function(res) {
								 const CITY_SELECTED_COOKIE         = "city_selected_v1";
								 const CITY_SELECTED_COOKIE_EXPIRES = 10000;
								 $.cookie(CITY_SELECTED_COOKIE, "selected", { expires : CITY_SELECTED_COOKIE_EXPIRES, path: "/"});
								 window.location.reload();
							 }
						 });
					 }
                 });
             }
		 }
	}

	function initSelects() {
		let selects = document.querySelectorAll('.field-select__select');
		selects.forEach(function (item) {
			new Choices(item, {
				searchEnabled: false,
				placeholderValue: 'Выберите',
			});
		});

		selects = [...document.querySelectorAll('[data-custom-select]')];
		selects.forEach(select => {
			$(select).SumoSelect({
				placeholder: "Выбрать...",
				captionFormat:'{0} выбрано',
				captionFormatAllSelected:'{0} выбрано',
			})
		});
	};

	function initFormsValidate() {
		if (!$.fn.validate) return false;
		let $forms = $('[data-validate-form]');
		// https://jqueryvalidation.org/
		$forms.validate({errorClass: 'field-text__error', errorElement: 'span'});
	};

	function initProductSlider() {
		new ProductItemSlider();
	}

	function initProductDetailCalc() {
		let calc = document.querySelector('[data-calculator]');
		new ProductDetailCalc(calc);
	}

	function initQuantityCounter() {
		[...document.querySelectorAll('[data-quantity-counter]:not(.is-inited)')].forEach(counter => {
			new QuantityCounter(counter);
		});
	}

	function initToCart(global = false, first = false) {
		[...document.querySelectorAll('[data-to-cart]:not(.is-inited)')].forEach(toCart => {
			new ToCart(toCart, { global, first });
		});
	}

	function initProductFeedback() {
		new ProductDetailFeedback();
	}

	function initCompare() {
		[...document.querySelectorAll('[data-compare-products]:not(.is-inited)')].forEach(el => {
			new CompareProducts(el);
		});
	}

	function initActionCounter() {
		new ActionCounters({ root: 'data-marketing-offer' });
	}

	function initTabodion() {
		new Tabodion();
	}

	function initMoreTexts() {
		new MoreTexts({ root: 'data-more-text' });
	}

	function scrollToElement() {
		let $btns = $('[data-scroll-to]');

		$btns.on('click', function(e) {
			e.preventDefault();
			let $this = $(this),
				$el = $($this.data('scroll-to')),
				headerOffset = $('#headerfixed').height();
			if (!headerOffset > 0) headerOffset = 0;
			$([document.documentElement, document.body]).animate({
				scrollTop: $el.offset().top - headerOffset
			}, 500);

		})
	}

	function clickToElement() {
		let $btns = $('[data-click-to]');

		$btns.on('click', function(e) {
			e.preventDefault();
			let $this = $(this),
				$el = $($this.data('click-to'));
			$el.click();
		})
	}

	function initAccordions() {
		[...document.querySelectorAll('[data-accordion]')].forEach(el => {
			new Accordion(el);
		})
	}

	function initSwitcher() {
		[...document.querySelectorAll('[data-switcher]:not(.is-inited)')].forEach(el => {
			new Switcher(el);
		})
	}

	function initForms() {
		[...document.querySelectorAll('[data-request]:not(.is-inited)')].forEach(el => {
			new FormsHandler(el);
		})
	}

	function modalReInit() {
		$(document).on('modal:open', function(event) {
			initSelects();
			initQuantityCounter();
			initSwitcher();
			initForms();
			initProductCard();
			loadModalByClick();
			new RentOfferCalc();
			initCardNumValidation();
			initTextTruncate();
			new Services(event.target);
			addReviewForm();
			initActionCounter();
			initNewFastViewModal();
			initDiscountRequestModal();
			initAuthModal();
			initDesignProjectModal();
			initVideoConsultationModal();
			initBonusB2bModal();
			initEcommClick();
			initUserConsent();
			// initCaruselSwiper();
		});
	}

	function checkBX() {
		if (typeof BX === "undefined") {
			window.BX = {
				message: function(string) {
					switch (string) {
						case 'JS_REQUIRED':
							return 'Заполните это поле!';
						case 'JS_FORMAT':
							return 'Неверный формат!';
						case 'JS_PASSWORD_COPY':
							return 'Пароли не совпадают!';
						case 'JS_PASSWORD_LENGTH':
							return 'Минимум 6 символов!';
						case 'JS_ERROR':
							return 'Неверно заполнено поле!';
						case 'JS_FILE_SIZE':
							return 'Максимальный размер 5мб!';
						case 'JS_DATE':
							return 'Некорректная дата!';
						case 'JS_RECAPTCHA_ERROR':
							return 'Пройдите проверку';
					}
				}
			}

			initJqueryValidator();
		}
	}

	function initJqueryValidator() {
		$.extend($.validator.messages, {
			required: BX.message('JS_REQUIRED'),
			email: BX.message('JS_FORMAT'),
			equalTo: BX.message('JS_PASSWORD_COPY'),
			minlength: BX.message('JS_PASSWORD_LENGTH'),
			remote: BX.message('JS_ERROR')
		});

		$.validator.addMethod(
			'regexp',
			function(value, element, regexp) {
				var re = new RegExp(regexp);
				return this.optional(element) || re.test(value);
			},
			BX.message('JS_FORMAT')
		);

		$.validator.addMethod(
			'filesize',
			function(value, element, param) {
				return this.optional(element) || (element.files[0].size <= param)
			},
			BX.message('JS_FILE_SIZE')
		);

		$.validator.addMethod(
			'date',
			function(value, element, param) {
				var status = false;
				if (!value || value.length <= 0) {
					status = false;
				} else {
					// html5 date allways yyyy-mm-dd
					var re = new RegExp('^([0-9]{4})(.)([0-9]{2})(.)([0-9]{2})$');
					var matches = re.exec(value);
					if (matches) {
						var composedDate = new Date(matches[1], (matches[3] - 1), matches[5]);
						status = ((composedDate.getMonth() == (matches[3] - 1)) && (composedDate.getDate() == matches[5]) && (composedDate.getFullYear() == matches[1]));
					} else {
						// firefox
						var re = new RegExp('^([0-9]{2})(.)([0-9]{2})(.)([0-9]{4})$');
						var matches = re.exec(value);
						if (matches) {
							var composedDate = new Date(matches[5], (matches[3] - 1), matches[1]);
							status = ((composedDate.getMonth() == (matches[3] - 1)) && (composedDate.getDate() == matches[1]) && (composedDate.getFullYear() == matches[5]));
						}
					}
				}
				return status;
			}, BX.message('JS_DATE')
		);

		$.validator.addMethod(
			'extension',
			function(value, element, param) {
				param = typeof param === 'string' ? param.replace(/,/g, '|') : 'png|jpe?g|gif';
				return this.optional(element) || value.match(new RegExp('.(' + param + ')$', 'i'));
			}, BX.message('JS_FILE_EXT')
		);

		$.validator.addMethod(
			'captcha',
			function(value, element, params) {
				return $.validator.methods.remote.call(this, value, element, {
					url: arNextOptions['SITE_DIR'] + 'ajax/check-captcha.php',
					type: 'post',
					data: {
						captcha_word: value,
						captcha_sid: function() {
							return $(element).closest('form').find('input[name="captcha_sid"]').val();
						}
					}
				});
			},
			BX.message('JS_ERROR')
		);

		$.validator.addMethod(
			'recaptcha',
			function(value, element, param) {
				var id = $(element).closest('form').find('.g-recaptcha').attr('data-widgetid');
				if (typeof id !== 'undefined') {
					return grecaptcha.getResponse(id) != '';
				} else {
					return true;
				}
			}, BX.message('JS_RECAPTCHA_ERROR')
		);

		$.validator.addMethod("strictemail",
            function(value, element) {
                return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value.toLowerCase());
            }, BX.message('JS_FORMAT')
        );


		$.validator.addClassRules({
			'phone': {
				regexp: arNextOptions['THEME']['VALIDATE_PHONE_MASK']
			},
			'confirm_password': {
				equalTo: 'input[name="REGISTER\[PASSWORD\]"]',
				minlength: 6
			},
			'password': {
				minlength: 6
			},
			'inputfile': {
				extension: arNextOptions['THEME']['VALIDATE_FILE_EXT'],
				filesize: 5000000
			},
			'captcha': {
				captcha: ''
			},
			'recaptcha': {
				recaptcha: ''
			},
			'strict-email': {
				strictemail: ''
			},
			'required': {
				required: true,
                normalizer: function(value) {
                  return $.trim(value);
                }
			}
		});

		// $.validator.addMethod("card_num_min", $.validator.methods.minlength,
		// 	$.validator.format("Пожалуйста, введите не менее {0} символов"));
		// $.validator.addMethod("card_num_max", $.validator.methods.maxlength,
		// 	$.validator.format("Пожалуйста, введите не более {0} символов"));
		// $.validator.addClassRules("card-number", { card_num_min: 12, card_num_max: 13 });
	}

	function initCardNumValidation() {
		var $cardNum = $('[data-card-num-field]');

		if ($cardNum.length < 1) return false;

		$.validator.addMethod(
			'bonusCard',
			function(value, element) {
				return this.optional(element) || /^[A-Za-z0-9]+$/i.test(value);
			}, 'Номер карты содержит недопустимые символы'
		);

		$cardNum.on("keypress", function(event) {
			var englishAlphabetAndWhiteSpace = /^[A-Za-z0-9]+$/;
			var key = String.fromCharCode(event.which);
			if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || englishAlphabetAndWhiteSpace.test(key)) {
				return true;
			}
			return false;
		});

		$cardNum.on("paste", function(e) {
			let clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
			let pastedData = clipboardData.getData("text");
			if (pastedData) {
				setTimeout(() => {
					this.value = pastedData.split(" ").join("");
				}, 0);
			}
			setTimeout(() => {
				$(this).valid();
			}, 50);
		});


		$cardNum.each(function(){
			setTimeout(() => {
				$(this).rules('add', {
					minlength: 12,
					maxlength: 13,
					messages: { // optional custom messages
						maxlength: jQuery.validator.format("Пожалуйста, введите не более {0} символов"),
						minlength: jQuery.validator.format("Пожалуйста, введите не менее {0} символов")
					},
					bonusCard: true,
				});
			}, 0);
		})
	}

	function loadStaticModal(content) {
	    let modal = $(content).clone(true).appendTo('body').modal();
	    modal.on($.modal.CLOSE, function(event, m) {
	    	m.elm.remove();
		});
		return modal;
	}

	function loadModalByUrl(url, params = {}) {
		$.ajax({
			url: url,
			dataType: "html",
			beforeSend: function() {
				document.body.classList.add('is-loading');
			},
			success: function(res) {
				document.body.classList.remove('is-loading');
				let modal;

				if ($(res).length > 1) {
					modal = $(res).filter(".modal__content").appendTo('body');
				} else {
					modal = $(res).appendTo('body');
				}

				modal.on('modal:open', function(event, m) {
					let backdrop = document.querySelector('.modal-backdrop');
					if (backdrop) {
						backdrop.remove();
					}

					//backdrop = document.createElement('div');
					//backdrop.className = 'modal-backdrop';
					//document.body.append(backdrop);

					if (params.modalParams) {
						if (params.modalParams.onShow) {
							params.modalParams.onShow(modal)
						}
					}

					if (params) {
						if (params.afterOpen) params.afterOpen({modal: modal.get(0)});
					}
				});

				modal.on('modal:close', function(event, m) {
					let backdrop = document.querySelector('.modal-backdrop');
					if (backdrop) {
						backdrop.remove();
					}

					backdrop = document.querySelector('.modal.in');
					if (backdrop) {
						backdrop.remove();
					}

					if (params.modalParams) {
						if (params.modalParams.onClose) {
							params.modalParams.onClose(modal)
						}
					}
				});

				let r = modal.modal(params.modalParams);

				modalReInit();
				if (params) {
					if (params.afterOpen) params.afterOpen({modal: modal.get(0)});
				}
			}
		});
	}

	function closeAllModalsHandler() {
		$(document).on('click', '.modal__close', function () {
			closeModals();
		})
	}

	function initTextTruncate() {
		let text = $('[data-truncate]');
		if (text.length) {
			text.each(function() {
				let $that = $(this),
					lineNum = $that.data('truncate');
				$that.truncate({
					lines: lineNum
				});
			})
		}
	}

	function initDiscountRequestModal() {
		new DiscountRequestModal();
	}

	function initBonuses() {
		new Bonuses();
	};

	function initRating() {
		let ratings = [...document.querySelectorAll('[data-rating]')];

		ratings.forEach(rating => {
			let ratingInit = new Rating({
				root: rating
			});

			ratingInit.init();
		});
	}

	function addReviewForm() {
		let form = document.querySelector('[data-add-review]');
		if (!form) return false;

		const stars = new StarRating('.star-rating');

		$('.review-modal__file-upload #upload-image').change(function() {
			let files = '';
			$('.review-modal__file-upload #upload-image')[0].files.forEach((element) => {
				files = files + '<li>'+element.name+'</li>';
			})
			$('#output-list').html(files)
		});

		function _callback(res) {
			closeModals();
			if (res.modalView) {
				let modal = $(res.modalView).appendTo('body').modal();
				if (res.script) eval(res.script);
				modal.on($.modal.CLOSE, function(event, m) {
					closeModals();
					if (res.redirect_url) window.location.href = res.redirect_url;
				});
			}

			//if (res.reviewId){
			//	if (res.childReviewView) {
			//		let reviewRow = document.querySelector(`[data-review="${res.reviewId}"]`),
			//			childReviews = [...document.querySelectorAll(`[data-child-review="${res.reviewId}"]`)];
//
			//		reviewRow.classList.add('reviews-grid__row--extended');
//
			//		if (childReviews.length) {
			//			$(res.childReviewView).insertAfter($(`[data-child-review=${res.reviewId}]`)[childReviews.length - 1]);
			//		} else {
			//			$(res.childReviewView).insertAfter($(reviewRow));
			//		}
//
			//		initMoreTexts();
			//		initModalGallery();
			//	}
			//}
		}

		new FormsHandler(form, _callback);
	}

	function initModalGallery() {
		const modalGallery = new ModalGallery();

		modalGallery.init();
	}

	function initBonuses() {
		new Bonuses();
	};

	function triggerAuthModal() {
		let $authLink = $('.personal-link');

		if (!$authLink.length) return false;

		$(document).on('click', '[data-trigger-auth-modal]', e => {
			e.preventDefault();
			$authLink.click();
		})
	}

	function fixCheckoutEmailField() {
		$(document).on('keydown', '#bx-soa-order-form [autocomplete=email]', e => {
			let key = e.keyCode;

			if (key === 32)
				e.preventDefault();
		});

		$(document).on('input', '#bx-soa-order-form [autocomplete=email]', function(e) {
			this.value = this.value.replace(/\s/g, "");
		})
	}

	function loadModalByClick() {
		let btns = document.querySelectorAll('[data-modal-openner]:not([data-modal-openner-inited])');

		if (!btns.length) return false;

		btns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();

				let url = btn.dataset.modalOpenner;

				loadModalByUrl(url);
			})
			btn.dataset.modalOpennerInited = true;
		})
	}

	function initTerminalId() {
		const terminalModule = new TerminalId({root: '[data-terminal-id]'});

		terminalModule.init();
	}

	function dateRange() {
		const roots = [...document.querySelectorAll('[data-date-range]')];

		if (!roots.length) return false;

		roots.forEach(el => {
			let fromInput = el.querySelector('[data-date-range-from]'),
				toInput = el.querySelector('[data-date-range-to]');

			[fromInput, toInput].forEach(input => {
				$(input).inputmask({
					alias: "datetime",
					inputFormat: "dd.mm.yy",
					placeholder: "дд.мм.гг",
					// oncomplete: () => {
					// 	if (input === fromInput) {
					// 		$(toInput).focus();
					// 	}
					// }
				});
			});
		})
	}

	function ordersControls() {
		const controls = new OrdersControls({rootSelector: '[data-orders-controls]'});
		controls.init();
	}

	function orderedItemsSearch() {
		const search = new ProductItemsSearch({rootSelector: '[data-product-items-search]'});
		search.init();
	}

	function fastViewModalInit() {
		$(document).on('fast-view-openned', e => {
			initActionCounter();
		})
	}

	function initCategoryFilter() {
		const filter = new CategoryFilter({root: '[data-category-filter]'});
		filter.init();
	}

	function initInfoModal() {
		if (window.infoModalActive) {
			loadModalByUrl("/include/modals/info.php");
		}
	}

	function initNeedPayModal() {
		let isNeedPayValue = new URL(window.location.href).searchParams.get('isNeedPay') === 'Y';
		if (isNeedPayValue) {
			let payButton = document.querySelector('[data-order-id]');
			let orderId = payButton.getAttribute('data-order-id');
			let orderNumber = payButton.getAttribute('data-order-num');
			loadModalByUrl("/include/modals/needPay.php?orderId=" + orderId + "&orderNumber=" + orderNumber);
		}
	}

	function initInfoPopup() {
		if (!$.cookie) return false;
		const infoCookie = $.cookie("info_popup_shown_v1");
		if(window.popupModalActive && !infoCookie) {
			loadModalByUrl("/include/modals/infoPopup.php");
			const date = new Date();
			const minutes = window.popupModalActivePeriod;
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			$.cookie("info_popup_shown_v1", "true", { expires: date, path: "/" });
		}
	}

	function initHeaderLoginMessage() {
		const messages = document.querySelectorAll(".main-header__personal-dropdown");

		if (!messages.length) return false;

		['click', 'touchstart'].forEach(event => {
			window.addEventListener(event, function(e){
				messages.forEach((message) => {
					if (!message.contains(e.target)){
						messages.forEach((message) => message.classList.remove("is-visible"))
					}
				})
			});
		})
	}

	function initProductAvailability() {
		[...document.querySelectorAll('[data-product-availability]:not(.is-inited)')].forEach(element => {
			new ProductAvailability(element);
		});
	}

	function bindCardInCart() {
		const bindCard = document.querySelector("[data-cart-bonus-card-bind]");
		if (!bindCard) return;

		bindCard.addEventListener("click", (e) => {
			e.preventDefault();
			loadModalByUrl("/local/components/dobrostroy/personal.bonus.card/templates/.default/modals/bonusCardPhone.php", { afterOpen: () => new Bonuses({ inCart: true }) });
		})
	}

	function initQuantityControls() {
		const controls = document.querySelectorAll("[data-quantity-control]");
		controls.forEach((control) => {
			new QuantityControl(control);
		})
	}

	function initCalculator() {
		const toggleBtn = document.querySelector("[data-calculator-toggle]");
		new CalculatorModal(toggleBtn);
	}

	function initGiftBonusesModal() {
		if (window.isAuthorized && $.cookie("gift_bonuses_popup_is_shown") === undefined && $.cookie("show_gift_bonus_modal") == 'true') {
			$.cookie("gift_bonuses_popup_is_shown", "true", { expires : 1, path: "/" });
			setTimeout(loadModalByUrl("/include/modals/bonusesInfo.php"), 5000);
		}
	}

	function initAppInstallModal() {
		if (($.cookie("show_app_install_modal") === undefined || $.cookie("show_app_install_modal") == 'true') && window.innerWidth <= 1024) {
			setTimeout(
				loadModalByUrl(
					"/include/modals/appInstall.php",
					{ onClose: function onClose() {
							$.cookie("show_app_install_modal", "false", { expires: 365, path: "/" });
							initChooseCityModal();
						}
					}
				),
				5000
			);
			$(document).on('click', '.modal--app-install .app-install-link', function () {
				$.cookie("show_app_install_modal", "false", { expires: 365, path: "/" });
			});
		} else {
			initChooseCityModal();
		}
	}

	function initChooseCityModal() {
		if (($.cookie("popup_was_save") === undefined || $.cookie("popup_was_save") == 'false') && window.innerWidth <= 1024) {
			setTimeout(
				loadModalByUrl(
					"/include/modals/chooseCity.php",
					{
						onClose: function onClose() {
							$.cookie("popup_was_save", "true", {expires: 365, path: "/"});
						}
					}
				), 5000);
		}
	}

	function initPhoneAuthSuccessModal() {
		var attachPhoneNotifyContent = localStorage.getItem('attachPhoneNotify');
		localStorage.removeItem('attachPhoneNotify');
		if (attachPhoneNotifyContent === 'showSuccessModal') {
			setTimeout(
				loadModalByUrl(
					"/include/modals/phoneAuthSuccess.php"
				),
				5000);
		}
	}

	function initEventOrderBtn()
	{
		let btn = document.querySelector('.order__create-btn');
		if (btn) {
			btn.addEventListener("click", (e) => {
				e.preventDefault();

				let link = btn.getAttribute('href');

				let bonusApplySuccess = bonusApplyModal(link);
				let bonusAuthSuccess = bonusAuthModal();
				let addBonusCardSuccess = addBonusCardModal();

				if (bonusApplySuccess && bonusAuthSuccess && addBonusCardSuccess) {
					window.location = link
				}
			})
		}
	}

	function bonusApplyModal(link) {
		let page = window.location.href;
		let cookieKey = 'popup_bonus_apply_show';
		let nextStep = false;

		if (
			($.cookie(cookieKey) === undefined || $.cookie(cookieKey) == 'true') &&
			page.indexOf('/basket/') !== -1 &&
			window.haveCardBonus !== undefined && window.haveCardBonus == true
		) {
			loadModalByUrl(
				"/include/modals/bonusApply.php",
				{
					onClose: function onClose() {
						$.cookie(cookieKey, "false", {expires: 365, path: "/"});
					}
				}
			)

			$(document).on('click', '#bonus-apply-modal .modal__close', function (e) {
				$.cookie(cookieKey, "false", { expires: 365, path: "/" });
			});

			$(document).on('click', '.bonus-apply__btn', function (e) {
				$.cookie(cookieKey, "false", { expires: 365, path: "/" });

				$('.jquery-modal').find('.modal__close').trigger('click');
				$('.label__check-bonuses').trigger('click');

				setTimeout(function(){
					window.location = link
				}, 1000)
			});
		} else {
			nextStep = true;
		}

		return nextStep;
	}

	function bonusAuthModal() {
		let page = window.location.href;
		let cookieKey = 'popup_bonus_auth_show';
		let nextStep = false;

		if (
			($.cookie(cookieKey) === undefined || $.cookie(cookieKey) == 'true') &&
			page.indexOf('/basket/') !== -1 &&
			window.bonusAuth !== undefined && window.bonusAuth == true
		) {
			loadModalByUrl(
				"/include/modals/bonusAuth.php",
				{
					onClose: function onClose() {
						$.cookie(cookieKey, "false", {expires: 365, path: "/"});
					}
				}
			)

			$(document).on('click', '.bonus-auth__btn, .bonus-reg__btn', function (e) {
				$.cookie(cookieKey, "false", { expires: 365, path: "/" });

				if ($(this).hasClass('bonus-auth__btn')) {
					$('.jquery-modal').find('.modal__close').trigger('click');

					loadModalByUrl('/ajax/form.php?type=auth&backurl=/basket/&auth=Y')
				}
			});
		} else {
			nextStep = true;
		}

		return nextStep;
	}

	function addBonusCardModal() {
		let page = window.location.href;
		let cookieKey = 'popup_bonus_add_card_show';
		let nextStep = false;

		if (
			($.cookie(cookieKey) === undefined || $.cookie(cookieKey) == 'true') &&
			page.indexOf('/basket/') !== -1 &&
			window.addBonusCard !== undefined && window.addBonusCard == true
		) {
			loadModalByUrl(
				"/include/modals/bonusAddCard.php",
				{
					onClose: function onClose() {
						$.cookie(cookieKey, "false", {expires: 365, path: "/"});
					}
				}
			)

			$(document).on('click', '.bonus-addcard__btn, .bonus-createcard__btn', function (e) {
				$.cookie(cookieKey, "false", { expires: 365, path: "/" });

				if ($(this).hasClass('bonus-addcard__btn')) {
					$('.jquery-modal').find('.modal__close').trigger('click');

					document.querySelector("[data-cart-bonus-card-bind]").click();
				}
			});
		} else {
			nextStep = true;
		}

		return nextStep;
	}

	function initCatalogFilters() {
		const $filter = $("[data-catalog-filter]");
		if (!$filter.length) return;
		$filter.removeClass("no-js");

		$(document).on('click', '[data-catalog-filter-expand]', function() {
			const $btn = $(this);
			const $currentFilter = $btn.parents("[data-catalog-filter]");
			const $filterBoxes = $currentFilter.find(".bx_filter_parameters_box");
			$filterBoxes.removeClass("hidden");
			$btn.parent().remove();
		});
	}

	function initBigSlider() {
		document.querySelectorAll('[data-big-slider]').forEach((slider)=>{
			new BigSlider({el: slider})
		})
	}

	function initShowMoreCatalog() {
		let btn = document.querySelector("[data-show-more-btn]"),
		container = document.querySelector("[data-show-more-container]"),
		pagination = document.querySelector("[data-show-more-pagination]"),
		callback = () => {
			initLazyLoad();
			initQuantityCounter();
			modalReInit();
			initProductCard();
			initShowMoreCatalog();
			initActionCounter();
			initEcommClick();
		};

		new ShowMoreBlock(btn, container, pagination, callback);
	}

	function initProductCard() {
		let elements = document.querySelectorAll("[data-product-card]:not(.is-inited)");

		elements.forEach(el=>{
			new ProductCard(el);
		})
	}

	function initFullProductCard() {
		initProductCard();
		initLazyLoad();
		loadModalByClick();
	}

	function initNewFastViewModal(){
		initLazyLoad();
		initQuantityCounter();
		modalReInit();
		initRating();
		new ModalFastViewSlider();
	}

	function initSortBlock(){
		let select = document.querySelector('[data-sort-select]');
		if(select){
			new SortBlock(select);
		}
	}
	function initSortBlock(){
		let selector = 'data-sort';
		new SortBlock(selector);
	}

	function initFixedContent(){
		let design = '.fixed-content',
		bx24 = '.b24-widget-button-wrapper.b24-widget-button-position-bottom-right'
		new FixedContent(design);
		new FixedContent(bx24);
	}

	function initInputModern() {
		new InputModernFactory({selector: 'data-input'});
	}

	function initAuthModal() {
		let modal = document.querySelector('[data-auth-modal]');

		if (modal) {
			new AuthModal(modal);
		}
	}

	function initDesignProjectModal() {
		let modal = document.querySelector('[data-design-project-modal]');

		if (modal) {
			let typeRadios = [...modal.querySelectorAll("input[type=radio][data-design-project-modal-type]")];
			let timeSelect = modal.querySelector("[data-design-project-modal-time]");
			typeRadios.forEach(input => {
				input.addEventListener("change", (e) => {
				    if (e.target.value === "2") {
			    		timeSelect.classList.add("hidden");
			    	} else {
						timeSelect.classList.remove("hidden");
					}
			    });
		    });
		}
	}

	function initVideoConsultationButtons() {
		let buttons = [...document.querySelectorAll('[data-video-consultation]')];
		buttons.forEach(btn => {
			btn.addEventListener("click", () => {
				ym(27695811, 'reachGoal', 'Videkonsult');
			})
		})
	}

	function initVideoConsultationModal() {
		let modal = document.querySelector('[data-video-consultation-modal]:not(.is-inited)');

		if (modal) {
			modal.classList.add("is-inited");
			let contactSelect = document.querySelector("[data-video-consultation-modal-contact] select");
			let phone = document.querySelector("[data-video-consultation-modal-phone]");
			let telegram = document.querySelector("[data-video-consultation-modal-telegram]");
			let telegramMessage = document.querySelector("[data-video-consultation-modal-t-message]");
			let skype = document.querySelector("[data-video-consultation-modal-skype]");
			let form = modal.querySelector("form");

			new FormsHandler(form, () => {
				ym(27695811, 'reachGoal', 'Videkonsult_send');
				return true;
			});

			let opts = {
				"1": "phone",
				"2": "telegram",
				"3": "whatsApp",
				"4": "skype",
				"5": "viber",
			}

			let hideAll = function() {
				phone.classList.add("hidden");
				telegram.classList.add("hidden");
				skype.classList.add("hidden");
				telegramMessage.classList.add("hidden");
			}

			$(contactSelect).on("change", function() {
				hideAll();
				let options = $(contactSelect).find('option');
				options.each(function(index, option){
					if (option.selected) {
						switch (opts[option.value]) {
							case "phone":
							case "viber":
							case "whatsApp": phone.classList.remove("hidden"); break;
							case "telegram": {
								telegram.classList.remove("hidden");
								telegramMessage.classList.remove("hidden");
								break;
							}
							case "skype": skype.classList.remove("hidden"); break;
						}
					}
				})
			});
		}
	}

	function initCheckout() {
		let checkout = document.querySelector("#app");
		if (checkout) {
			const app = new Checkout();
			app.init();
		}
	}

	function initComparePage() {
		let page = document.querySelector("#app-compare");
		if (page) {
			const app = new Compare();
			app.init();
		}
	}

	function initCityDropdown() {
		let page = document.querySelector("#main");
		if (page) {
			const app = new CityDropdown(page);
		}
	}


	function initBXPageObject() {
		/**
		 * Перенесено из ядра битрикса
		 * После обновления перестал работать метод BX.reload из-за отсутствия BX.PageObject.
		 * Проблема уходила после авторизации
		 */
		if (window.BX && !window.BX.PageObject) {
			window.BX.PageObject = {
				getRootWindow: function()
				{
					return BX.PageObject.getTopWindowOfCurrentHost(window);
				},

				isCrossOriginObject: function(currentWindow)
				{
					try
					{
						void currentWindow.location.host;
					}
					catch (e)
					{
						// cross-origin object
						return true;
					}

					return false;
				},

				getTopWindowOfCurrentHost: function(currentWindow)
				{
					if (
						!BX.PageObject.isCrossOriginObject(currentWindow.parent)
						&& currentWindow.parent !== currentWindow
						&& currentWindow.parent.location.host === currentWindow.location.host
					)
					{
						return BX.PageObject.getTopWindowOfCurrentHost(currentWindow.parent);
					}

					return currentWindow;
				},

				getParentWindowOfCurrentHost: function(currentWindow)
				{
					if (BX.PageObject.isCrossOriginObject(currentWindow.parent))
					{
						return currentWindow;
					}

					return currentWindow.parent;
				}
			};
		}
	}

	function initBonusB2bModal() {
		let el = document.querySelector("[data-bonus-b2b-modal]");
		if (el) {
			let modal = new BonusB2bModal(el);
		}
	}

	function initEcommClick() {
		let btns = document.querySelectorAll("[data-ecomm-item-click]:not([data-ecomm-item-click-inited]");
		btns.forEach(btn => btn.addEventListener("click", (e) => {
			btn.setAttribute("data-ecomm-item-click-inited", "");
			if (window.BX && window.BX.onCustomEvent) {
				BX.onCustomEvent('onCompleteAction', [{action: 'productEcommClicked', id: btn.dataset.item}]);
			}
		}));
	}

	function initUserConsent() {
		let els = document.querySelectorAll("[data-consent]:not([data-consent-inited]");
		els.forEach(el => new UserConsent(el));
	}

	function initAnalytics() {
		function addToCart(data) {
			dataLayer.push({
				'event': 'ecommerce',
				'EE': 'addToCart',
				'ecommerce': {
					'add':  {
						'products': [{
							'id': data.id,
							'name': data.name,
							'category': data.category,
							'brand': data.brand,
							'price': data.price,
							'quantity': data.quantity
						}]
					}
				}
			});
		}
		function removeFromCart(data) {
			dataLayer.push({
				'event': 'ecommerce',
				'EE': 'RemoveFromCart',
				'ecommerce': {
					'remove':  {
						'products': [{
							'id': data.id,
							'name': data.name,
							'category': data.category,
							'brand': data.brand,
							'price': data.price,
							'quantity': data.quantity
						}]
					}
				}
			});
		}
		function ecommClick(data) {
			dataLayer.push({
				'event': 'ecommerce',
				'EE': 'productClick',
				'ecommerce': {
					'click':  {
						'actionField': {
							'list': window.dataLayerEvents.List
						},
						'products': [{
							'id': data.id,
							'name': data.name,
							'category': data.category,
							'brand': data.brand,
							'price': data.price,
							'position': data.position
						}]
					}
				}
			});
		}
		if (window.BX && window.BX.onCustomEvent) {
			BX.addCustomEvent('onCompleteAction', function(data) {
				if (window.dataLayerEvents && window.dataLayerEvents.arProducts) {
					let itemData = window.dataLayerEvents.arProducts[data.id];
					if (!itemData) return;

					switch (data.action) {
						case "productQuantityChanged": {
							itemData.quantity = data.diff;
							(data.type === "inc") ? addToCart(itemData) : removeFromCart(itemData);
							break;
						}
						case "productRemovedFromCart": {
							itemData.quantity = data.quantity;
							removeFromCart(itemData);
							break;
						}
						case "productAddedToCart": {
							itemData.quantity = data.quantity;
							addToCart(itemData);
							break;
						}
						case "productEcommClicked": {
							ecommClick(itemData);
							break;
						}
					}
				}
			});
		}
	}
	if (jQuery.validator !== "undefined") {
		jQuery.extend(jQuery.validator.messages, {
			required: "Это обязательное поле.",
			remote: "Please fix this field.",
			email: "Не верный email адрес.",
			url: "Please enter a valid URL.",
			date: "Не верная дата.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Не верное числовое значение.",
			digits: "Please enter only digits.",
			creditcard: "Please enter a valid credit card number.",
			equalTo: "Значения полей не совпадают.",
			accept: "Please enter a value with a valid extension.",
			maxlength: jQuery.validator.format("Не длиннее {0} символов."),
			minlength: jQuery.validator.format("Не короче {0} символов."),
			rangelength: jQuery.validator.format("Значение должно быть от {0} до {1} символов."),
			range: jQuery.validator.format("Значение должно быть от {0} до {1}."),
			max: jQuery.validator.format("Максимальное значение {0}."),
			min: jQuery.validator.format("Минимальное значение {0}.")
		});
	}
}
